import { Checkbox, Input, Popover, ScrollArea } from '@mantine/core';
import { FC, useState } from 'react';

import { SelectionOption } from '@/models/SelectionOption.ts';

interface Props {
    label: string;
    displayText: string;
    options: SelectionOption[];
    selected: string[];
    handleSelectAll?: () => void;
    handleToggle: (value: string) => void;
    showWarningIfNoneIsSelected?: boolean;
}

const CustomMultiSelect: FC<Props> = ({
    label,
    displayText,
    options,
    selected,
    handleSelectAll,
    handleToggle,
    showWarningIfNoneIsSelected = false,
}) => {
    const [is_open, setIsOpen] = useState(false);
    const should_show_warning = showWarningIfNoneIsSelected && selected.length === 0;

    return (
        <div className="flex-grow">
            <Popover
                opened={is_open}
                onChange={setIsOpen}
                // eslint-disable-next-line custom/no-mantine-style-props
                width="target"
                withArrow={false}
                classNames={{
                    dropdown: 'p-4',
                }}
            >
                <Popover.Target>
                    <Input
                        value={displayText}
                        readOnly
                        onClick={() => setIsOpen((open) => !open)}
                        error={should_show_warning}
                    />
                </Popover.Target>

                <Popover.Dropdown>
                    <ScrollArea.Autosize className="max-h-[300px]">
                        <div className="flex flex-col gap-2">
                            <Checkbox
                                label={label}
                                checked={selected.length === options.length}
                                indeterminate={selected.length > 0 && selected.length < options.length}
                                onChange={handleSelectAll}
                            />
                            <div className="flex flex-col gap-1">
                                {options.map((option) => (
                                    <Checkbox
                                        key={option.value}
                                        label={option.label}
                                        checked={selected.includes(option.value)}
                                        onChange={() => handleToggle(option.value)}
                                    />
                                ))}
                            </div>
                        </div>
                    </ScrollArea.Autosize>
                </Popover.Dropdown>
            </Popover>
        </div>
    );
};

export default CustomMultiSelect;
